import { render, staticRenderFns } from "./OrderShipping.vue?vue&type=template&id=55560845&"
import script from "./OrderShipping.vue?vue&type=script&lang=ts&"
export * from "./OrderShipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports